<template>
  <div class="bl-register-wrap">
    <div class="bl-bg-head"></div>
    <div class="bl-register-box" v-loading="loading">
      <div class="flex">
        <div class="theme-color pointer font-size-13" @click="goPrev" style="right: auto; left: 20px;">
          <span class="iconfont iconfanhui"></span>{{ $t('login2s.back') }}
        </div>
        <div class="theme-color pointer font-size-13 .m-r-4" @click="registrationBackHome">
          <span class="backHomeS">{{ $t('logins.backHome') }}</span>
        </div>
      </div>
      
      <v-register-step :stepType='registerId'></v-register-step>
      <div v-if="registerId === 1">
        <div class="v-register-comment">
          <div class="v-register-title v-register-flex">
            <div>
              {{ $t('login2s.resigerTitle') }}
              <!-- <span class="theme-color font-size-14 pointer" style="line-height: 14px" @click="changeResiger">{{type == 'email' ? $t("login2s.changeResiger[0]") : $t("login2s.changeResiger[1]")}}</span> -->
            </div>
            <div>
              <span class="font-size-14 m-r-4">{{$t('login2s.noAccount[1]')}}</span>
              <span class="theme-color font-size-14 pointer" style="line-height: 14px" @click="loginEvent">{{$t('login2s.register[1]')}}</span>
            </div>
          </div>
          <el-form action="" @keyup.enter.native="regLoginMess" label-position="top">
            <div class="v-pass-register-module p-b-24" v-show="isPassLogin">
              <v-input :labelName="$t('email')" v-model="inputVal.email"></v-input>
              <div class="font-size-14 label margin-b-8">
                <span class="v-label-color">{{ $t('code') }}</span>
              </div>
              <el-row ref="verifyWidth" style="width:100%">
                <vue-simple-verify 
                  ref="verify" 
                  :width="width"
                  :height="32" 
                  @success="slideOk" 
                  :tips="$t('registerTips')" 
                  :successTips="$t('registerSuccessTips')" 
                  :movedColor="movedColor"
                />
              </el-row>
            </div>
            <el-button type="primary" :loading='loading' class="v-big-btn" @click="regLoginMess">{{ $t('Next') }}</el-button>
          </el-form>
          <div class="v-register-flex font-size-12 p-b-24 p-t-24">
            <div>
              <span>{{ $t('You sign up and agree') }}</span>
              <span class="theme-color pointer"><router-link to="/agreement" target="_blank"> {{ $t('Privacy agreement') }}</router-link></span>
            </div>
            <TouristChat />
          </div>
        </div>
      </div>
      <div v-if="registerId === 2">
        <div class="emailConfirmation">
          <div>
            <p class="font-size-20 p-t-24">{{$t('emailConfirmation')}}</p>
            <div class="email_img">
              <img :src="emailImage"/>
            </div>
            <h4 class="font-size-16 p-b-24">{{$t('emailTitle')}}</h4>
            <ul class="font-size-13 text-left p-b-24 emailUl">
              <li><div>{{$t('emailContent1')}}<span>{{$t('emailContent2')}}</span>{{$t('emailContent3')}}</div></li>
              <li><div>{{$t('emailContent4')}}</div></li>
            </ul>
            <div class="v-register-flex font-size-12 p-b-24 p-t-24">
              <div>
                <el-button size="mini" :disabled="!show" @click="reSend">{{ $t('resendMessage') }} <span v-if="!show"> ({{ times }}s)</span></el-button>
              </div>
              <TouristChat />
            </div>
          </div>
          
        </div>
      </div>
      <loginBottom></loginBottom>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import vInput from '@/components/vInput'
// import vCodes from '@/components/vCodes'
import { sendEmailCode, checkEmail, getLimitVerificationToken
, registerUserByEmail 
, registerUserByEmailNotCheck
} from '@/api/index'
import { reg } from '@/utils/function'
import { setToken } from '@/utils/auth'
import emailImage from '@/assets/images/email.png'
import vRegisterStep from '@/components/login/register_step.vue'
import TouristChat from '@/components/chat/TouristChat'
import loginBottom from '@/components/login/loginBottom.vue'
import VueSimpleVerify from 'vue-simple-verify'
import '../../../node_modules/vue-simple-verify/dist/vue-simple-verify.css'

export default {
  name: 'vRegister',
  components: {
    vInput,
    vRegisterStep,
    TouristChat,
    loginBottom,
    VueSimpleVerify
    // vCodes
  },
  data() {
    return {
      width: 540,
      times:300,
      show:true,
      slideCode:false,
      movedColor:"",
      registerId:'',
      emailImage: emailImage,
      // 类型(手机号|邮箱)
      type: this.$route.params.type || 'email',
      // 显示(手机号|邮箱) 模块
      isPassLogin: this.$route.params.type == 'email' ? true : false,
      // form 表单
      inputVal: {
        email: '',
        Authorization: '',
        // password: '',
        // repassword: ''
      },
      loading: false,
      disabled: false,
      notCheck: true   //true: 不需要验证  false: 需要验证
    }
  },
  computed: {
    ...mapGetters(['language', 'loginAccount', 'subjectType'])
  },
  mounted() {
    this.movedColor = `#0D2863`
    this.registerId = parseInt(this.$route.params.id)
    this.inputVal.email = this.loginAccount

    if (this.registerId == '1') {
        window.PC.$RangersEventLoginAndRegister('Createanaccount_view')
    } else if (this.registerId == '2') {
        window.PC.$RangersEventLoginAndRegister('Emailconfirmationpage_view', {
            account: this.loginAccount
        })
    }

    if(this.registerId === 2) {
      if(this.show) {
        this.getCode()
      }
    }
    setTimeout(()=>{
      console.log('this.$refs.verifyWidth.---->', this.$refs.verifyWidth)
      if (this.$refs.verifyWidth) {
        this.width = this.$refs.verifyWidth.$el.clientWidth
      }
    },1)
  },
  watch: {
    '$route': function() {
      this.registerId = parseInt(this.$route.params.id)
    }
  },
  methods: {
    goPrev() {
      if(this.registerId == 1) {
        this.loginSource({ path: '/login/person', replaceStatus: true })
      } else if (this.registerId == 2) {
        this.$router.replace({ path: '/register/email/1' })
      }
    },
    // 验证字段
    regLoginMess() {
      let obj = this.inputVal
      let param = {}
      if (!obj.email) {
        this.$notify.error(this.$t('Please enter your email'))
        return false
      } else if (!reg.email.test(obj.email)) {
        this.$notify.error(this.$t('Please enter your correct email address'))
        return ''
      } else if (!obj.Authorization) {
        this.$notify.error(this.$t('slideCode'))
        this.$refs.verify.reset();
        this.slideCode = false
        obj.Authorization = '';
        return false
      }
      window.PC.$RangersEventLoginAndRegister('Emailaccountcreation_continue_click', {
        account: obj.email
      })
      param = JSON.parse(JSON.stringify(this.inputVal))
      this.$store.commit('SET_LOGIN_ACCOUNT', this.inputVal.email)
      this.submit(param)
    },
    getCode() {
      this.show = false
      this.timer = setInterval(()=>{
        this.times--
        if(this.times===0){
          this.show = true
          clearInterval(this.timer)
        }
      },1000)
    },
    reSend(){
      window.PC.$RangersEventLoginAndRegister('Emailconfirmationpage_Resend_click', {
        account: this.loginAccount
      })
      var Authorization;
      let params = {
        email: this.loginAccount
      }
      getLimitVerificationToken(params)
      .then(res => {
        return res.data
      })
      .then(res => {
        if (res.code === 1000 && res.data) {
          Authorization = res.data
          setToken(Authorization)
        }
      }).then(()=>{
        let data = {
          email: this.loginAccount,
          Authorization:Authorization
        };
        this.goRegisterUserByEmail(data);
      })
    },
    // 注册
    submit(params) {
      this.goRegisterUserByEmail(params);
    },
    goRegisterUserByEmail(params){
      this.loading = true
      if (this.notCheck) {
          registerUserByEmailNotCheck(params).then(res => {
          this.loading = false
          if(res.data.code === 1000) {
            if (res.data.data.userExist) {
              this.$notify.error({
                message: this.$t('infoExistence')
              });
              this.$refs.verify.reset();
              this.slideCode = false
              this.inputVal.Authorization = '';
            }else if (res.data.data.verificationError) {
              this.$notify.error({
                message: this.$t('codeRrror')
              });
              this.$refs.verify.reset();
              this.slideCode = false
              this.inputVal.Authorization = '';
            }else if (res.data.data.userExist == false && res.data.data.verificationError == false && res.data.data.requireSetPassword) {
              //用户不存在且验证码正确且需要设置密码 进入跳转到设置密码页，且设置token
              // setToken(res.data.data.token)
              this.$store.commit('SET_LOGIN_ACCOUNT', this.inputVal.email)
              this.$tracking('010101')
              this.$router.push({'path': '/register/password/vis',query: {token:res.data.data.token,languageType:this.language}})
            }

            else if (res.data.data.userExist == false && res.data.data.verificationError == false && res.data.data.requireSetPassword == false) {
              //用户不存在且验证码正确且需要设置密码 进入邮箱验证页，且设置token
              this.$store.commit('SET_LOGIN_ACCOUNT', this.inputVal.email)
              this.$tracking('010101')
              this.$router.push({'path': '/register/email/2'})
              if(this.registerId == 2) {
                this.times = 300;
                this.getCode();
              }
            }

          }else {
            this.$refs.verify.reset();
            this.inputVal.Authorization = '';
            this.slideCode = false
            this.show = true
          }
        }).catch(()=> {
          this.loading = false
          this.$refs.verify.reset();
          this.inputVal.Authorization = '';
          this.slideCode = false
          this.show = true
        })
      } else {
        registerUserByEmail(params).then(res => {
          this.loading = false
          if(res.data.code === 1000) {
            if (res.data.data.userExist) {
              this.$notify.error({
                message: this.$t('infoExistence')
              });
              this.$refs.verify.reset();
              this.slideCode = false
              this.inputVal.Authorization = '';
            }else if (res.data.data.verificationError) {
              this.$notify.error({
                message: this.$t('codeRrror')
              });
              this.$refs.verify.reset();
              this.slideCode = false
              this.inputVal.Authorization = '';
            }else if (res.data.data.userExist == false && res.data.data.verificationError == false && res.data.data.requireSetPassword) {
              //用户不存在且验证码正确且需要设置密码 进入跳转到设置密码页，且设置token
              // setToken(res.data.data.token)
              this.$store.commit('SET_LOGIN_ACCOUNT', this.inputVal.email)
              this.$tracking('010101')
              this.$router.push({'path': '/register/password/vis',query: {token:res.data.data.token,languageType:this.language}})
            }

            else if (res.data.data.userExist == false && res.data.data.verificationError == false && res.data.data.requireSetPassword == false) {
              //用户不存在且验证码正确且需要设置密码 进入邮箱验证页，且设置token
              this.$store.commit('SET_LOGIN_ACCOUNT', this.inputVal.email)
              this.$tracking('010101')
              this.$router.push({'path': '/register/email/2'})
              if(this.registerId == 2) {
                this.times = 300;
                this.getCode();
              }
            }

          }else {
            this.$refs.verify.reset();
            this.inputVal.Authorization = '';
            this.slideCode = false
            this.show = true
          }
        }).catch(()=> {
          this.loading = false
          this.$refs.verify.reset();
          this.inputVal.Authorization = '';
          this.slideCode = false
          this.show = true
        })
      }
    },
    // 发送验证码事件（邮箱/手机号）
    callback(res) {
      if (res.type == 'sendCode') {
        
        if (this.type == 'email') {
          // 发送邮箱验证码
          // 邮箱除重
          checkEmail({
            email: this.inputVal.email
          }).then(res => {
            return res.data
          }).then(res => {
            if(res.code === 1000 && !res.data.repeat) {
              // 发送邮箱验证码
              sendEmailCode({
                email: this.inputVal.email
              }).then(res => {
                if (res.data.code == 1000) {
                  setToken(res.headers.authorization)
                  this.$notify.success(this.$t('The verification code has been sent'))
                }
              })
            } else {
              this.$confirm(this.$t('employee.Email already exist'), this.$t('common.productTipsTitle'), {
                confirmButtonText: this.$t("login2s.register[1]"),
                type: 'warning'
              }).then(() => {
                this.loginEvent()
              }).catch(() => {
                this.disabled = true
              })
              this.disabled = true
              return false
            }
          }).catch(() => {
            this.disabled = true
          }).finally(() => {
            this.disabled = false
          })
          
        }
      }
    },
    // 切换注册
    changeResiger() {
      if (this.type == 'email') {
        // 邮箱注册
        this.$router.push({path: "/l-register/mobile"})
      } else {
        // 手机号注册
        this.$router.push({path: "/l-register/email"})
      }
    },
    // 登录
    loginEvent() {
      window.PC.$RangersEventLoginAndRegister('Emailaccountcreation_Signinnow_click')
      this.$router.push({path: '/login/person',query: {t: 'email'}})
    },
    // 滑动验证完成
    slideOk() {
      if (!this.inputVal.email) {
        this.$notify.error(this.$t('Please enter your email'))
        this.inputVal.Authorization = '';
        this.slideCode = false
        // setTimeout(()=>{
          this.$refs.verify.reset();
        // },600)
      } else if (!reg.email.test(this.inputVal.email)) {
        this.$notify.error(this.$t('Please enter your correct email address'))
        this.inputVal.Authorization = '';
        this.slideCode = false
        // setTimeout(()=>{
          this.$refs.verify.reset();
        // },600)
      } else {
        window.PC.$RangersEventLoginAndRegister('Emailaccountcreation_Slidingverification_click')
        let params = {
          email:this.inputVal.email
        }
        getLimitVerificationToken(params)
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            this.slideCode = true;
            this.inputVal.Authorization = res.data
            setToken(this.inputVal.Authorization)
          }
        })
      }
    }
  }
}
</script>
<style lang="stylus">
.simple-verify .verify-bar {
  left: 2px !important;
  top: 0px !important;
  width: 44px !important;
  .icon{
    background-color $color-main !important;
  }
}

.emailConfirmation{
  width 380px;
  margin 0 auto;
  text-align center;
  height 600px
  .email_img{
    width 261px
    height 183px
    margin 40px auto
    img{
      width 100%
      height 100%
    }
  }
  .emailUl{
    li{
      display: flex;
      line-height: 1.66;
      span{
        font-weight: bold;
      }
      div{
        margin-left: 5px;
      }

      & + li {
        margin-top: 12px;
      }
    }
    li:before{
      content: "\2022";
      color: $color-main;
      font-size: 18px;
    }
  }
}
</style>
